module.exports = __webpack_public_path__ + "media/images/gallery/constellations/ursa_minor/umi_vis-6af0d167725b4a3e64509906960bb243.jpg";